import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../login/login.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class HomeComponent {

  feedbackUrl: string = "https://dev.a5o.dev.asdh.aws.renault.com/api/rest/preLogin/happi";

  constructor(private translate: TranslateService, private loginService: LoginService) { }

  get vhcpu_title() {
    return this.translate.instant('ACCOUNT_TYPE_LABEL6') + ' \n ' + this.translate.instant('ACCOUNT_TYPE_LABEL6_BIS');
  }
  
}